import { useEffect, useState } from "react";

export const useUrlParameterFromRegex = (regex, defaultReturn = []) => {
  const { hash } = window.location;
  const [match, setMatch] = useState(() => hash.match(regex));

  useEffect(() => {
    const hashChangeHandler = () => {
      const { hash } = window.location;
      setMatch(hash.match(regex));
    };
    window.addEventListener("hashchange", hashChangeHandler);
    return () => window.removeEventListener("hashchange", hashChangeHandler);
  }, [regex]);

  return match || defaultReturn;
};
